// ─── Hook ─────────────────────────────────────────────────────────────────────

import { useGetApiV1AccesscontrolRoles } from '@/shared/api/generated';

/**
 * Hook para listar todos os roles disponíveis.
 *
 * @returns Lista de roles com estado de loading/error
 *
 * @example
 * ```tsx
 * const { roles, isLoading } = useRoleList();
 * ```
 */
export function useRoleList() {
  const query = useGetApiV1AccesscontrolRoles();

  return {
    roles: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
